export default {"id":"3916200b","attrs":{"viewBox":"0 0 28 28","width":"28","height":"28"}}